document.addEventListener('DOMContentLoaded', () => {
  // ── Mobile nav toggle ────────────────────────
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });
  }

  // ── Mobile dropdown accordion (≤980px) ────────────
  const isMobile = () => window.innerWidth <= 980;

  // Level 1 → Level 2
  document.querySelectorAll('.nav-item--has-dropdown').forEach(item => {
    const link = item.querySelector(':scope > .nav-item__link');
    if (!link) return;
    link.addEventListener('click', e => {
      if (!isMobile()) return;
      e.preventDefault();
      const open = item.classList.contains('is-open');
      // Close siblings
      item.closest('.site-nav').querySelectorAll('.nav-item--has-dropdown').forEach(s => s.classList.remove('is-open'));
      item.classList.toggle('is-open', !open);
    });
  });

  // Level 2 → Level 3
  document.querySelectorAll('.nav-dropdown__item--has-flyout').forEach(item => {
    const link = item.querySelector(':scope > .nav-dropdown__link');
    if (!link) return;
    link.addEventListener('click', e => {
      if (!isMobile()) return;
      e.preventDefault();
      const open = item.classList.contains('is-open');
      item.closest('.nav-dropdown').querySelectorAll('.nav-dropdown__item--has-flyout').forEach(s => s.classList.remove('is-open'));
      item.classList.toggle('is-open', !open);
    });
  });

  // ── Lightbox with zoom ───────────────────────
  // NOTE: product card thumbnails are deliberately EXCLUDED here. A product card
  // is a link to the product page and must navigate on click — opening a lightbox
  // instead swallowed the click-through. Full-size viewing lives on the product page.
  const galleryImages = document.querySelectorAll(
    '.gallery-grid img, .rte-gallery img, .public-art-content img, .product-page__media img, .spotlight__media img'
  );

  if (!galleryImages.length) return;

  const lightbox = document.createElement('div');
  lightbox.className = 'image-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Expanded artwork image');
  lightbox.innerHTML = `
    <button class="image-lightbox__close" type="button" aria-label="Close expanded image">Close</button>
    <div class="image-lightbox__stage">
      <img class="image-lightbox__image" alt="" draggable="false">
    </div>
    <div class="image-lightbox__controls">
      <button type="button" class="image-lightbox__zoom" data-zoom="out" aria-label="Zoom out">&minus;</button>
      <span class="image-lightbox__level">100%</span>
      <button type="button" class="image-lightbox__zoom" data-zoom="in" aria-label="Zoom in">+</button>
      <span class="image-lightbox__hint">Scroll or pinch to zoom &middot; drag to pan &middot; double-click to reset</span>
    </div>
  `;
  document.body.appendChild(lightbox);

  const stage = lightbox.querySelector('.image-lightbox__stage');
  const lightboxImage = lightbox.querySelector('.image-lightbox__image');
  const closeButton = lightbox.querySelector('.image-lightbox__close');
  const levelLabel = lightbox.querySelector('.image-lightbox__level');

  const MIN_SCALE = 1;
  const MAX_SCALE = 6;
  let scale = 1;
  let originX = 0;
  let originY = 0;
  let dragging = false;
  let moved = false;
  let startX = 0;
  let startY = 0;
  let startOriginX = 0;
  let startOriginY = 0;
  let pinchActive = false;
  let pinchStartDist = 0;
  let pinchStartScale = 1;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  // The grid thumbnail is served at width=900. Swap in a full-resolution
  // variant so zooming reveals real brushwork instead of upscaled mush.
  const highResSrc = (image) => {
    const src = image.currentSrc || image.src;
    try {
      const url = new URL(src, window.location.href);
      if (url.searchParams.has('width')) {
        url.searchParams.set('width', '2400');
        return url.toString();
      }
      return src;
    } catch (err) {
      return src;
    }
  };

  const clampOrigin = () => {
    const stageRect = stage.getBoundingClientRect();
    const imgRect = lightboxImage.getBoundingClientRect();
    const baseW = imgRect.width / scale;
    const baseH = imgRect.height / scale;
    const maxX = Math.max(0, (baseW * scale - stageRect.width) / 2);
    const maxY = Math.max(0, (baseH * scale - stageRect.height) / 2);
    originX = clamp(originX, -maxX, maxX);
    originY = clamp(originY, -maxY, maxY);
  };

  const applyTransform = () => {
    lightboxImage.style.transform =
      `translate(${originX}px, ${originY}px) scale(${scale})`;
    stage.classList.toggle('is-zoomed', scale > 1);
    levelLabel.textContent = `${Math.round(scale * 100)}%`;
  };

  const resetTransform = () => {
    scale = 1;
    originX = 0;
    originY = 0;
    applyTransform();
  };

  const setScale = (next, focalX, focalY) => {
    const prev = scale;
    scale = clamp(next, MIN_SCALE, MAX_SCALE);
    if (scale === prev) return;

    if (scale === MIN_SCALE) {
      originX = 0;
      originY = 0;
    } else if (typeof focalX === 'number') {
      // Keep the point under the cursor anchored while zooming.
      const stageRect = stage.getBoundingClientRect();
      const cx = focalX - stageRect.left - stageRect.width / 2;
      const cy = focalY - stageRect.top - stageRect.height / 2;
      const ratio = scale / prev;
      originX = cx - (cx - originX) * ratio;
      originY = cy - (cy - originY) * ratio;
      clampOrigin();
    } else {
      clampOrigin();
    }
    applyTransform();
  };

  const openLightbox = (image) => {
    lightboxImage.src = highResSrc(image);
    lightboxImage.alt = image.alt || 'Expanded artwork image';
    resetTransform();
    lightbox.classList.add('is-open');
    document.body.classList.add('lightbox-open');
    closeButton.focus();
  };

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    document.body.classList.remove('lightbox-open');
    lightboxImage.removeAttribute('src');
    resetTransform();
  };

  galleryImages.forEach((image) => {
    image.setAttribute('tabindex', '0');
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', image.alt ? `Expand image: ${image.alt}` : 'Expand artwork image');

    image.addEventListener('click', () => openLightbox(image));

    image.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLightbox(image);
      }
    });
  });

  // ── Zoom interactions ────────────────────────
  stage.addEventListener('wheel', (event) => {
    event.preventDefault();
    const step = event.deltaY < 0 ? 1.15 : 1 / 1.15;
    setScale(scale * step, event.clientX, event.clientY);
  }, { passive: false });

  lightbox.querySelectorAll('[data-zoom]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      setScale(btn.dataset.zoom === 'in' ? scale * 1.4 : scale / 1.4);
    });
  });

  lightboxImage.addEventListener('dblclick', (event) => {
    event.preventDefault();
    if (scale > 1) {
      resetTransform();
    } else {
      setScale(2.5, event.clientX, event.clientY);
    }
  });

  lightboxImage.addEventListener('mousedown', (event) => {
    if (scale <= 1) return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startY = event.clientY;
    startOriginX = originX;
    startOriginY = originY;
    lightboxImage.classList.add('is-panning');
    event.preventDefault();
  });

  window.addEventListener('mousemove', (event) => {
    if (!dragging) return;
    moved = true;
    originX = startOriginX + (event.clientX - startX);
    originY = startOriginY + (event.clientY - startY);
    clampOrigin();
    applyTransform();
  });

  window.addEventListener('mouseup', () => {
    dragging = false;
    lightboxImage.classList.remove('is-panning');
  });

  const touchDist = (touches) => {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  stage.addEventListener('touchstart', (event) => {
    if (event.touches.length === 2) {
      pinchActive = true;
      pinchStartDist = touchDist(event.touches);
      pinchStartScale = scale;
    } else if (event.touches.length === 1 && scale > 1) {
      dragging = true;
      moved = false;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      startOriginX = originX;
      startOriginY = originY;
    }
  }, { passive: true });

  stage.addEventListener('touchmove', (event) => {
    if (pinchActive && event.touches.length === 2) {
      const dist = touchDist(event.touches);
      scale = clamp(pinchStartScale * (dist / pinchStartDist), MIN_SCALE, MAX_SCALE);
      clampOrigin();
      applyTransform();
      event.preventDefault();
    } else if (dragging && event.touches.length === 1) {
      moved = true;
      originX = startOriginX + (event.touches[0].clientX - startX);
      originY = startOriginY + (event.touches[0].clientY - startY);
      clampOrigin();
      applyTransform();
      event.preventDefault();
    }
  }, { passive: false });

  stage.addEventListener('touchend', (event) => {
    if (event.touches.length < 2) pinchActive = false;
    if (event.touches.length === 0) dragging = false;
  });

  // ── Close behaviour ─────────────────────────
  closeButton.addEventListener('click', closeLightbox);

  stage.addEventListener('click', (event) => {
    // Clicking the dark area around the image closes; dragging does not.
    if (event.target === stage && !moved) closeLightbox();
  });

  document.addEventListener('keydown', (event) => {
    if (!lightbox.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === '+' || event.key === '=') setScale(scale * 1.4);
    if (event.key === '-' || event.key === '_') setScale(scale / 1.4);
    if (event.key === '0') resetTransform();
  });

  window.addEventListener('resize', () => {
    if (scale > 1) {
      clampOrigin();
      applyTransform();
    }
  });
});
